import { logEvent } from 'firebase/analytics';
import { analytics } from '../firebase-config.js';
import { animateInTheWizDesktop } from './video-player.js';

// DOM Elements
const headerNew = document.getElementById("header-new");
const logoNew = document.getElementById("logo-new");
const homeSpacerNew = document.getElementById("home-spacer");
const hamburgerMenuNew = document.getElementById("hamburger-new");
const hamburgerMenuBar1New = document.getElementById('bar-1-new');
const hamburgerMenuBar2New = document.getElementById('bar-2-new');
const hamburgerMenuBar3New = document.getElementById('bar-3-new');
const mobileNavNew = document.getElementById('mobile-nav-new');
const listItems = document.querySelectorAll("mobile-nav-new ul li");
const desktopNavBar = document.getElementById('nav-desktop');
const sections = document.querySelectorAll("section");
const navDesktopItems = document.querySelectorAll(".nav-desktop-item");
const mobileNavDots = document.querySelectorAll(".dot");

// State variables
let hamburgerMenuNewIsExpanded = false;
let headerIsExpanded = false;
let pageLoaded = false;
let loadedOnDesktop = false;

// -- CHECK IF WEBSITE IS OPENED ON MOBILE BROWSER -------------------------------- //

function adjustMarginForMobile() {
    var isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    var theWizDiv = document.getElementById('the-wiz-desktop');

    if (isMobile && theWizDiv) {
        theWizDiv.style.marginLeft = '0px';
    }
}

// -- PAGE LOAD HANDLER ---------------------------------------------------------- //

function handlePageLoad() {
    pageLoaded = true;
}

if (document.readyState === "complete") {
    handlePageLoad();
} else {
    window.addEventListener("load", handlePageLoad);
}

// -- HEADER LOGO ANIMATION ON PAGE LOAD ----------------------------------------- //

document.addEventListener("DOMContentLoaded", () => {
    const minimumDelay = 2000;
    const startTime = Date.now();
    const logoContainer = document.getElementById("logo-new");
    const headerNew = document.getElementById("header-new");

    let animationFinished = false;
    let hasCompletedOneLoop = false;
    let waitingForLoopToFinish = false;

    const checkAnim = setInterval(() => {
        if (window.anim) {
            clearInterval(checkAnim);

            // Attach loopComplete event listener
            window.anim.addEventListener("loopComplete", () => {
                if (!hasCompletedOneLoop) {
                    hasCompletedOneLoop = true;
                }

                if (pageLoaded) {
                    animationFinished = true;
                    stopAnimationAndSlideUp();
                } else {
                    waitingForLoopToFinish = true;
                }
            });

            // If the page loads while an animation loop is in progress, wait for that loop to complete
            window.addEventListener("load", () => {
                pageLoaded = true;

                if (hasCompletedOneLoop && waitingForLoopToFinish) {
                    stopAnimationAndSlideUp();
                }
            });
        }
    }, 100);

    function stopAnimationAndSlideUp() {
        if (window.anim) {
            window.anim.stop();
        }

        const animatedLogo = document.getElementById("animated-logo");
        animatedLogo.remove();

        const staticLogo = document.getElementById("static-logo");
        staticLogo.classList.remove("logo-hidden");

        setTimeout(() => {
            logoContainer.style.transition = ".25s";
        }, 50);

        logoContainer.classList.add("loaded");

        setTimeout(() => {
            headerNew.classList.add("slide-up");

            // Show main content when curtain slides up
            const mainContent = document.querySelector('.main-content-wrapper');
            if (mainContent) {
                mainContent.classList.add('visible');
            }

            setTimeout(() => {
                headerNew.classList.add("relative");
                homeSpacerNew.style.height = "173px";
            }, 500);
            HandleHamburgerMenu();
        }, 0);

        setTimeout(() => {
            animateInTheWizDesktop();
        }, 1000);
    }
});

// -- HAMBURGER MENU FUNCTIONALITY ----------------------------------------------- //

hamburgerMenuNew.addEventListener('click', function () {
    if (!hamburgerMenuNewIsExpanded) {
        hamburgerMenuNewIsExpanded = true;

        CloseHamburgerMenuUI();

        logEvent(analytics, 'hamburger_opened');

        headerNew.classList.remove("relative");
        homeSpacerNew.style.height = "332px";
        logoNew.classList.add('hide');

        document.querySelectorAll("#mobile-nav-new ul li").forEach((item) => {
            item.classList.add("pointer");
        });

        headerNew.classList.remove("slide-up");
        setTimeout(() => {
            setTimeout(mobileNavNew.classList.add('show'));
            headerIsExpanded = true;
        }, 250);
    } else {
        hamburgerMenuNewIsExpanded = false;

        OpenHamburgerMenuUI();

        headerNew.classList.add("slide-up");
        mobileNavNew.classList.remove('show');

        document.querySelectorAll("#mobile-nav-new ul li").forEach((item) => {
            item.classList.remove("pointer");
        });

        document.getElementById("mobile-nav-new").classList.add("disable-links");

        setTimeout(() => {
            headerNew.classList.add("relative");
            homeSpacerNew.style.height = "173px";
            logoNew.classList.remove('hide');
            headerIsExpanded = false;
        }, 500);
    }
});

function CloseHamburgerMenuUI() {
    hamburgerMenuBar1New.classList.add('rotation-top');
    hamburgerMenuBar2New.classList.add('adjust-margin');
    hamburgerMenuBar3New.classList.add('rotation-bottom');
}

function OpenHamburgerMenuUI() {
    hamburgerMenuBar1New.classList.remove('rotation-top');
    hamburgerMenuBar2New.classList.remove('adjust-margin');
    hamburgerMenuBar3New.classList.remove('rotation-bottom');
}

window.addEventListener('resize', HandleHamburgerMenu);

function HandleHamburgerMenu() {
    if (window.innerWidth <= 767) {
        if (hamburgerMenuNewIsExpanded) {
            headerNew.classList.remove('slide-up');
            logoNew.classList.add('hide');
            mobileNavNew.classList.add('show');
        }
        hamburgerMenuNew.classList.add("show");
    } else {
        if (hamburgerMenuNewIsExpanded) {
            headerNew.classList.add('slide-up');
            logoNew.classList.remove('hide');
            mobileNavNew.classList.remove('show');
        }
        hamburgerMenuNew.classList.remove("show");
    }
}

// -- MOBILE NAVIGATION HANDLERS ------------------------------------------------- //

setupMobileNavHandler("nav-home-mobile-new", "home-new", "mobile_nav_home_clicked");
setupMobileNavHandler("nav-services-mobile-new", "services", "mobile_nav_services_clicked");
setupMobileNavHandler("nav-process-mobile-new", "process", "mobile_nav_process_clicked");
setupMobileNavHandler("nav-work-mobile-new", "work", "mobile_nav_work_clicked");
setupMobileNavHandler("nav-plans-mobile-new", "plans", "mobile_nav_plans_clicked");
setupMobileNavHandler("nav-faq-mobile-new", "faq", "mobile_nav_faq_clicked");

function setupMobileNavHandler(navId, scrollToId, analyticsEvent) {
    const navElement = document.getElementById(navId);
    const navParent = navElement.parentElement;

    navParent.addEventListener('click', () => {
        hamburgerMenuNewIsExpanded = false;
        logEvent(analytics, analyticsEvent);
        headerNew.classList.add("slide-up");
        mobileNavNew.classList.remove('show');
        OpenHamburgerMenuUI();

        setTimeout(() => scrollToMobile(document.getElementById(scrollToId)), 800);

        setTimeout(() => {
            headerNew.classList.add("relative");
            homeSpacerNew.style.height = "173px";
            logoNew.classList.remove('hide');
        }, 500);
    });
}

function scrollToMobile(element) {
    var headerOffset = 55;
    var elementPosition = element.getBoundingClientRect().top;
    var offsetPosition = elementPosition + window.pageYOffset - headerOffset;
    window.scroll({
        behavior: 'smooth',
        left: 0,
        top: offsetPosition
    });
}

// -- DESKTOP NAVIGATION BAR ----------------------------------------------------- //

window.addEventListener("load", function() {
    if (window.innerWidth >= 768) {
        loadedOnDesktop = true;
    }
    if (window.innerWidth < 767) {
        loadedOnDesktop = false;
    }
    animateInDesktopNavBar();
    adjustMarginForMobile();
});

window.addEventListener('resize', animateInDesktopNavBar);
window.addEventListener('resize', animateInTheWizDesktop);

function animateInDesktopNavBar() {
    if (window.innerWidth >= 768) {
        if (loadedOnDesktop) {
            desktopNavBar.style.transition = .65 + "s";
        } else {
            desktopNavBar.style.transition = .35 + "s";
        }
        desktopNavBar.classList.add("nav-desktop-show");
    } else {
        desktopNavBar.style.transition = .35 + "s";
        desktopNavBar.classList.remove("nav-desktop-show");
    }
}

// -- ACTIVE ITEM OF DESKTOP AND MOBILE NAV -------------------------------------- //

window.onscroll = () => {
    var current = "";

    sections.forEach((section) => {
        const sectionTop = section.offsetTop;
        if (scrollY >= sectionTop - 60) {
            current = section.getAttribute("id");
        }
    });

    navDesktopItems.forEach((div) => {
        div.style.transition = 'none';
        div.classList.remove("active-white");
        div.classList.remove("active-black");
        if (div.classList.contains(current)) {
            if (div.classList.contains('black')) {
                div.classList.add("active-black");
            } else {
                div.classList.add("active-white");
            }
        }
    });

    mobileNavDots.forEach((div) => {
        div.classList.remove("mobile-active");
        if (div.classList.contains(current)) {
            div.classList.add("mobile-active");
        }
    });
};

// -- SCROLLING TO SECTION FOR BOTH MOBILE AND DESKTOP --------------------------- //

function scrollTo(element) {
    window.scroll({
        behavior: 'smooth',
        left: 0,
        top: element.offsetTop
    });
}

// -- MAIN CTA CLICK HANDLER ----------------------------------------------------- //

document.getElementById("main-cta").addEventListener('click', () => {
    logEvent(analytics, 'view_plans_cta_clicked');

    if (window.innerWidth < 768) {
        scrollToMobile(document.getElementById("plans"));
    } else {
        scrollTo(document.getElementById("plans"));
    }
});

// -- DESKTOP NAV BAR CLICK HANDLERS --------------------------------------------- //

document.getElementById("nav-desktop-new-home").addEventListener('click', () => {
    scrollTo(document.getElementById("home"));
    logEvent(analytics, 'desktop_nav_home_clicked');
});

document.getElementById("nav-desktop-new-services").addEventListener('click', () => {
    scrollTo(document.getElementById("services"));
    logEvent(analytics, 'desktop_nav_services_clicked');
});

document.getElementById("nav-desktop-new-process").addEventListener('click', () => {
    scrollTo(document.getElementById("process"));
    logEvent(analytics, 'desktop_nav_process_clicked');
});

document.getElementById("nav-desktop-new-work").addEventListener('click', () => {
    scrollTo(document.getElementById("work"));
    logEvent(analytics, 'desktop_nav_work_clicked');
});

document.getElementById("nav-desktop-new-plans").addEventListener('click', () => {
    scrollTo(document.getElementById("plans"));
    logEvent(analytics, 'desktop_nav_plans_clicked');
});

document.getElementById("nav-desktop-new-faq").addEventListener('click', () => {
    scrollTo(document.getElementById("faq"));
    logEvent(analytics, 'desktop_nav_faq_clicked');
});
